// @flow

import React, { Component } from 'react';
import styled from 'styled-components';
import type { Theme } from '../../../types';

type Props = {
  className: string,
  count: number,
};

class Count extends Component<Props> {
  shouldComponentUpdatenewProps(newProps: Props) {
    const { count } = this.props;
    return newProps.count !== count;
  }

  render() {
    const { count, className } = this.props;
    return (<div className={className}>{count}</div>);
  }
}

export default styled<typeof Count, Theme, any>(Count)`
  color: ${props => props.theme.assortment.facets.count.color};
`;
